import React from 'react';
import CptApp from './CptApp';

const App = () => {
    return <CptApp />;
};
export default App;
